import { BaseService } from './base.service';

export class SettingsService extends BaseService {
  constructor() {
    super('settings');
  }

  async getSystemSettings() {
    try {
      const allSettings = await this.table.toArray();
      return allSettings.filter(setting => setting.isSystem === true);
    } catch (error) {
      console.error('Erreur lors de la récupération des paramètres système:', error);
      return [];
    }
  }

  async getUserSettings() {
    try {
      const allSettings = await this.table.toArray();
      return allSettings.filter(setting => setting.isSystem === false);
    } catch (error) {
      console.error('Erreur lors de la récupération des paramètres utilisateur:', error);
      return [];
    }
  }

  async getSettingByKey(key) {
    return this.table
      .where('key')
      .equals(key)
      .first();
  }

  async updateSetting(key, value, options = {}) {
    const { type = 'string', description = '', isSystem = false } = options;
    
    try {
      // Vérifier si le paramètre existe déjà
      const existingSetting = await this.getSettingByKey(key);
      
      if (existingSetting) {
        // Mettre à jour l'enregistrement existant
        return this.update(existingSetting.id, { 
          value, 
          updatedAt: new Date(),
          lastSync: new Date()
        });
      } else {
        // Créer un nouvel enregistrement
        return this.create({ 
          key, 
          value, 
          type, 
          description, 
          isSystem,
          createdAt: new Date(),
          updatedAt: new Date(),
          lastSync: new Date()
        });
      }
    } catch (error) {
      console.error(`Erreur lors de la mise à jour du paramètre ${key}:`, error);
      throw error;
    }
  }

  async getSettingsByType(type) {
    return this.table
      .where('type')
      .equals(type)
      .toArray();
  }

  async deleteSetting(key) {
    const setting = await this.getSettingByKey(key);
    if (setting) {
      return this.delete(setting.id);
    }
    return false;
  }

  async deleteAllSettings() {
    return this.table.clear();
  }

  async deleteDuplicateSettings() {
    try {
      const allSettings = await this.table.toArray();
      const seenKeys = new Set();
      const duplicates = [];

      // Identifier les doublons
      allSettings.forEach(setting => {
        if (seenKeys.has(setting.key)) {
          duplicates.push(setting);
        } else {
          seenKeys.add(setting.key);
        }
      });

      // Supprimer les doublons (garder le plus récent)
      for (const duplicate of duplicates) {
        await this.delete(duplicate.id);
      }

      return duplicates.length;
    } catch (error) {
      console.error('Erreur lors de la suppression des doublons:', error);
      throw error;
    }
  }
} 